import { useCallback, useEffect, useState } from "react"
import { usePagination } from "../../hooks/usePagination"
import ApiService from "../../services/apiService"
import { method } from "lodash"
import { format } from "date-fns"
import RightIcon from "../svg/RightIcon"
import LeftIcon from "../svg/LeftButton"
import { Button, Dropdown, DropdownItem, DropdownMenu, DropdownToggle, Label } from "reactstrap"
import DateTimePicker from 'react-datepicker'
import Breadcrumbs from "../../coreComponents/breadcrumbs"
import Table from "../table/Table";
import { useNavigate } from "react-router-dom"
import ExportExcel from "../reports/ExportExcel"
import { toast } from "react-toastify"
import { divIcon } from "leaflet"

const GetSchemeWiseSummary = () =>{
      
    const [isEnabled,setIsEnabled] = useState<any>()
    const [fromDateTime,setFromDateTime] = useState<any>()
    const [toDateTime,  setToDateTime] = useState<any>()
    const [SchemeVillages, setSchemeVillages] = useState<any>()
    const [selectedSchemeVillage,setSelectedShemeVillage] =useState<any>()
    const [dropdownOpen, setDropdownOpen] = useState(false);
    const [seconddropdown,setseconddropdown] = useState(false);
    const toggleDropdown = () => setDropdownOpen(!dropdownOpen);
    const toggleDropdown2 = () => setseconddropdown(!seconddropdown);
    const [unitPrice,setUnitPrice] = useState()
    const navigate = useNavigate();
    const [showDateFilters, setShowDateFilters] = useState(false);
    const [selectedReport, setSelectedReport] = useState();
    const[allSchemeVillageId,setAllSchemeVillageId] = useState<any>()
    const [pageSize,setPageSize] = useState<number>(10)
    const [pageNumber,setPageNumber] = useState<number>(1)
    const [totalCount,setTotalCount] = useState<number>(0)
    const[data,setData] = useState<any[]>()
    const [schemeVillageId,setSchemeVillageId]= useState<string|number|any>()
    const [reportType,setReportType] = useState<string>('')
    const SelectReport = [
        { id: 0, report: 'YEARLY' },
        
        { id: 3, report: 'MONTHLY' }
    ]

    

    const getFirstTimeSchemeSummary = async() =>{

        
         
        try{
             const response = await ApiService.axiosApi(`/allschemesummary/getallchargesreportbyschemeid`,{

                method:'GET',
                params:{
                     pageNumber:pageNumber,
                     pageSize:pageSize,
                     fromDate:format(fromDateTime, 'yyyy-MM-dd HH:mm:ss'),
                     toDate:format(toDateTime, 'yyyy-MM-dd HH:mm:ss'),
                     ReportType:selectedReport == 'MONTHLY' ? 'MONTH': 'YEAR',
                     schemeVillageId:schemeVillageId

                }

             })  

             if(response.success){
                 setTotalCount(response.data.totalCount)
                 setData(response.data.data)
                 
             }else if(response.data.data.length == 0){
                  toast.error('No data found for the give date')
             }else{
                 toast.error('Unable to get data at this moment')
             }


        }catch(e){
             console.log(e)
        }


       }

       useEffect(()=>{
           getFirstTimeSchemeSummary()
       },[pageNumber])


    const totalPages = Math.ceil(totalCount / pageSize);

    const handleNext = useCallback(() => {
        setPageNumber((prev) => Math.min(totalPages, prev + 1))
    }, [setPageNumber, totalPages])



    const handlePrev = useCallback(() => {
        setPageNumber((prev) => Math.max(1, prev - 1))
    }, [setPageNumber, totalPages])

    // const handleClick = () =>{
              
    //     if(fromDateTime){
    //          const from = format(fromDateTime, 'yyyy-MM-dd HH:mm:ss');
    //          setFromDate(from);
    //     }
    //     if(toDateTime){
    //          const to = format(toDateTime, 'yyyy-MM-dd HH:mm:ss');
    //          setToDate(to);
    //     }
    //     setIsEnabled(true);
       
    // }

      const getSchemeVillage  = async() =>{
         try{
             const response = await ApiService.axiosApi(`/schemevillage`,{
                 method:'GET',
                 params:{
                    pageNumber:0,
                    pageSize:0
                 }
                 

             })
             if(response.success){
                 setSchemeVillages(response.data.data)
             }else{
                 console.log('unable to get scheme village')
             }
         }catch(e){
             console.log('unable to get scheme village',e)
         }
      }

      const getWaterCharges = async() =>{
         try{
             const response = await ApiService.axiosApi(`/watercharges/bydate/${fromDateTime?format(fromDateTime, 'yyyy-MM-dd HH:mm:ss'):''}`,{
                 method:'GET'
             })
             if(response.success){
                 setUnitPrice(response.data.unitPrice)
             }else{
                console.log('no unit price')
             }
         }catch(e){
             console.log(e)
         }
      }

      useEffect(()=>{
          getSchemeVillage();
          getWaterCharges();
      },[fromDateTime])
      
      let updatedData
      if(data){
           updatedData = data?.map((data)=>{
              return{
                 ...data,
                 dateTime:format(new Date(data.dateTime),'dd-MM-yyyy')
              }
         })
      }

      const getAllSchemeVillageById = async() =>{

        try{
             const response = await ApiService.axiosApi(`/allschemesummary/getallchargesreportbyschemeid`,{
                 method:'GET',
                 params:{
                     FromDate:format(fromDateTime, 'yyyy-MM-dd HH:mm:ss'),
                     ToDate:format(toDateTime, 'yyyy-MM-dd HH:mm:ss'),
                     ReportType:selectedReport =='MONTHLY'?'MONTH':'YEAR',
                     SchemeVillageId:allSchemeVillageId,
                     pageNumber:0,
                     pageSize:0 
                 }
             })

             if(response.success){
                 return response.data.data
             }else{
                 console.log('unable to get scheme report')
             }
        }catch(e){
            console.log(e)
        }
         
      }
      const validateGenerate = () => {


        if (!selectedSchemeVillage) {
            toast.warning("Please select scheme/village");
            return false;
          }


        if (!selectedReport) {
          toast.warning("Please select report type");
          return false;
        }
      
        
        if (!fromDateTime) {
          toast.warning("Please select From Date");
          return false;
        }
      
        if (!toDateTime) {
          toast.warning("Please select To Date");
          return false;
        }
      
        if (new Date(fromDateTime) > new Date(toDateTime)) {
          toast.warning("From Date cannot be greater than To Date");
          return false;
        }
      
        return true;
      };
      

     return(
          <>
           <Breadcrumbs mainTitle="Scheme Summary" parent="Summary" />
            <div className='w-100 bg-white px-2 py-2'>
                <div className='bg-light-primary d-flex justify-content-around align-items-center'
                    style={{
                        width: '100%',
                        height: '100px',
                        border: '1px solid rgb(43, 94, 94, 0.1)',
                    }}>

                    <div className="d-flex flex-column" style={{
                         width:'12%'
                    }}>
                        <Label>Scheme/Village:</Label>

                        <Dropdown isOpen={dropdownOpen} toggle={toggleDropdown} style={{width:'100%'}} >
                            <DropdownToggle
                                className="custom-dropdown-toggle d-flex align-items-center justify-content-between"
                                   
                                style={{
                                    fontWeight: 500,
                                    borderRadius: '5px',
                                    padding: '8px 16px',
                                    width: '100%',
                                    height: '36px',
                                   
                                }}
                                color="whitesmoke"
                            >
                                {selectedSchemeVillage ? selectedSchemeVillage : "select"}
                            </DropdownToggle>

                            <DropdownMenu
                                className="custom-dropdown-menu"
                                style={{

                                    overflowY: 'auto',
                                    boxShadow: '0 0.5rem 1rem rgba(0, 0, 0, 0.1)',
                                    borderRadius: '8px',
                                    padding: '8px 0',
                                    width: '100%'
                                }}
                            >
                                {SchemeVillages?.map((data: any) => (
                                    <DropdownItem onClick={() => {
                                        setSchemeVillageId(data.id)
                                        setAllSchemeVillageId(data.id)
                                        setSelectedShemeVillage(data.scheme_Village)
                                    }} key={data.id}>
                                        {data.scheme_Village}
                                    </DropdownItem>
                                ))}
                            </DropdownMenu>
                        </Dropdown>

                       

                    </div>

                    <div className="report-input-div mx-3 input-border d-flex flex-column "style={{
                         width:'12%'
                    }}>
                       <Label >Report Type:</Label>
                        <Dropdown isOpen={seconddropdown} toggle={toggleDropdown2} style={{width:'100%'}}>
                            <DropdownToggle
                                className="custom-dropdown-toggle d-flex align-items-center justify-content-between report-dropdown"

                                style={{
                                   
                                    fontWeight: 500,
                                    borderRadius: '5px',
                                    padding: '8px 16px',
                                    width: '100%',
                                    height: '36px'
                                }}
                                color="whitesmoke"
                            >
                                {selectedReport ? selectedReport : "select"}
                            </DropdownToggle>

                            <DropdownMenu
                                className="custom-dropdown-menu"
                                style={{
                                    width: '100%',
                                    overflowY: 'auto',
                                    boxShadow: '0 0.5rem 1rem rgba(0, 0, 0, 0.1)',
                                    borderRadius: '8px',
                                    padding: '8px 0',
                                }}
                            >
                                {SelectReport?.map((data: any) => (
                                    <DropdownItem onClick={() => {
                                        setSelectedReport(data.report)
                                        setReportType(data.report == 'MONTHLY'? 'MONTH':'YEAR')
                                    }} key={data.id}>
                                        {data.report}
                                    </DropdownItem>
                                ))}
                            </DropdownMenu>
                        </Dropdown>
                    </div>

                    


                  <div className="report-input-div mx-3 input-border d-flex flex-column ">
                        <Label>From Date:</Label>
                        <DateTimePicker
                            className="report-input"
                            dateFormat="dd/MM/yyyy"
                            placeholderText="DD-MM-YYYY"
                           
                            onChange={(date: any) => setFromDateTime(date)}
                            selected={fromDateTime}
                            isClearable
                            timeFormat="HH:mm:ss"
                        />
                    </div>


                    <div className="report-input-div mx-3  input-border  d-flex flex-column">
                        <Label>To Date:</Label>
                        <DateTimePicker
                            className="report-input"
                            dateFormat="dd/MM/yyyy"
                            placeholderText="DD-MM-YYYY"
                            showTimeSelect
                            onChange={(date: any) => setToDateTime(date)}
                            selected={toDateTime}
                            isClearable
                          
                        />
                    </div> 

                    <div className=" d-flex flex-column" style={{width:'8%'}}>
                        <Label style={{ visibility: 'hidden' }}>Generate</Label>
                        <Button className="px-0" color="success" onClick={()=>{
                            
                            if (!validateGenerate()) return;
                            getFirstTimeSchemeSummary()
                            }}style={{
                                width:'100%', whiteSpace: 'nowrap',
                                overflow: 'hidden',
                                textOverflow: 'ellipsis' 
                             }}>
                            Generate
                        </Button>
                    </div>
                     
                     <div style={{width:'8%'}}>
                     <Label style={{ visibility: 'hidden' }}>Generate</Label>
                        <ExportExcel
                         getData={getAllSchemeVillageById}
                         fileName='Scheme Wise Summary'
                         unitPrice={unitPrice}
                         EffectiveFrom={fromDateTime?format(fromDateTime, 'yyyy-MM-dd HH:mm:ss'):''}
                         selectedChakScheme={selectedSchemeVillage}
                         hiddenColumns={['id','schemeVillage']}
                         columnOrder={['dateTime','distributionVolume','totalCharges']}
                        />
                     </div>  
                   
                    
                </div> 


                <div className='mt-2'>
              <Table
                        isAction={false}
                        data={updatedData ?? []}
                        columns={[
                                { header: 'Period', accessor: 'dateTime' },
                               { header: 'Distribution(m³)', accessor: 'distributionVolume' },
                               {header:'Charges',accessor:'totalCharges'}
                           ]}

                        buttons={[
                           
                        ]}
                    />  {(!updatedData || updatedData.length === 0) && (
    <div className="d-flex justify-content-center py-3 text-muted">
        No data available
    </div>
)}

                    <div className=" d-flex justify-content-end align-content-center" style={{ marginRight: '10px', marginTop: '10px' }}>
                        <p style={{ marginRight: '10px', marginTop: '8px' }}>
                            Page {pageNumber} of {totalPages}
                        </p>
                        <button
                            onClick={handlePrev}
                            disabled={pageNumber === 1}
                            className={`icon-button ${pageNumber === totalPages ? 'disabled' : ''}`}
                        >
                            <LeftIcon className="icon" />
                        </button>
                        <button
                            className={`icon-button ${pageNumber === totalPages ? 'disabled' : ''}`}
                            onClick={handleNext}
                            disabled={pageNumber === totalPages}
                        >
                            <RightIcon className="icon" />
                        </button>
                    </div>
                </div>



              
            </div>
          </>
     )
}
export default GetSchemeWiseSummary;